/*
  DORVETTI — vídeos decorativos bajo demanda (MOV-012).
  Para <video data-dv-autoplay data-src="…">: se descarga al acercarse a la pantalla, se reproduce en
  silencio solo mientras se ve y se pausa al salir o al ocultar la pestaña. Con reduced motion, nada.
*/

(() => {
  'use strict';
  if (window.DvLazyVideo) return; // puede cargarse desde varias secciones

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const tracked = new Set();
  const visible = new WeakSet();

  // Un vídeo que la persona ha pausado con sus controles (data-user-paused) no se reanuda solo.
  const sync = (video) => {
    if (visible.has(video) && !reduceMotion.matches && !document.hidden && video.dataset.userPaused !== 'true') {
      if (!video.getAttribute('src') && video.dataset.src) {
        video.preload = 'auto';
        video.src = video.dataset.src;
      }
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(() => {});
    } else if (!video.paused) {
      video.pause();
    }
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              if (isIntersecting) visible.add(target);
              else visible.delete(target);
              sync(target);
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  function init(scope = document) {
    scope.querySelectorAll('video[data-dv-autoplay]').forEach((video) => {
      if (tracked.has(video) || !observer) return;
      tracked.add(video);
      video.addEventListener('playing', () => video.classList.add('is-playing'));
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('visibilitychange', () => tracked.forEach(sync));
  reduceMotion.addEventListener?.('change', () => tracked.forEach(sync));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.DvLazyVideo = { init, sync };
})();
